import React, { useState, useEffect } from "react";
import { db, storage } from "../../firebase"; // Import Firebase Firestore and Storage
import { setDoc, doc, getDoc } from "firebase/firestore"; // Firestore methods
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Firebase Storage methods
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GrFormNextLink } from "react-icons/gr";
import "./RegistrationForm.css";
import Navbar from "../../components/navigationbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';

const RegistrationForm = () => {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    qualification: "",
    otherQualification: "",
    specialization: "",
    otherSpecialization: "",
    aadhaarCardNumber: "",
    whatsappNumber: "",
    address1: "",
    address2: "",
    registrationNumber: "",
    registrationDate: "",
    nameOfCouncil: "",
    renewalDate: "",
    photo: null,
    degreeCertificate: null,
    aadhaarCard: null,
    registrationCertificate: null,
    additionalDegreeCertificate: null,
  });

  const [currentStep, setCurrentStep] = useState(1); // Tracks the current form step (1: input fields, 2: documents)

  const Navigate = useNavigate();

  const [certificateImages, setCertificateImages] = useState([]); // Store URLs of uploaded documents

  useEffect(() => {
    toast("Please fill out your registration form.", {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }, []);

  // useEffect to retrieve username from localStorage and fetch user data from Firebase
  useEffect(() => {
    const fetchUserData = async () => {
      const storedUsername = localStorage.getItem("username");
      if (storedUsername) {
        try {
          const userDocRef = doc(db, "users", storedUsername);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            setFormValues((prevValues) => ({
              ...prevValues,
              firstName: 'Dr. ' + userData.firstName,
              lastName: userData.lastName,
              middleName: userData.middleName,
              email: userData.email,
              phone: userData.phone,
            }));
          } else {
            Navigate("/login");
            toast.error("No user data found for the given username.");
          }
        } catch (error) {
          toast.error("Error fetching user data: " + error.message);
        }
      }
    };

    fetchUserData();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormValues({ ...formValues, [name]: files[0] });
  };
  const username = localStorage.getItem("username"); // Use username from localStorage
  if (!username) {
    toast.error("Unknown User. Please register!");
    return;
  }

  const uploadFile = async (file, fileName) => {
    const storageRef = ref(storage, `users/${username}/certificates/${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef); // Return the file URL after upload
  };

  const handleNextStep = () => {
    // Check if all required fields in step 1 are filled
    const {
      firstName,
      lastName,
      email,
      phone,
      dob,
      gender,
      aadhaarCardNumber,
      whatsappNumber,
      address1,
      registrationNumber,
      registrationDate,
      nameOfCouncil,
      renewalDate,
    } = formValues;

    if (
      !firstName ||
      !lastName ||
      !email ||
      !phone ||
      !dob ||
      !gender ||
      !aadhaarCardNumber ||
      !whatsappNumber ||
      !address1 ||
      !registrationNumber ||
      !registrationDate ||
      !nameOfCouncil ||
      !renewalDate
    ) {
      toast.error("Please fill out all required fields before proceeding.");
      return;
    }
   
    setCurrentStep(2); // Proceed to document upload step
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate file sizes (1MB limit)
    const {
      photo,
      degreeCertificate,
      aadhaarCard,
      registrationCertificate,
      additionalDegreeCertificate,
    } = formValues;
    const files = [
      photo,
      degreeCertificate,
      aadhaarCard,
      registrationCertificate,
      additionalDegreeCertificate,
    ];

    for (let file of files) {
      if (file && file.size > 1048576) {
        // 1MB in bytes
        toast.error("File size must be under 1MB");
        return;
      }
    }

   

    try {
      setLoading(true);
      // Upload files and get URLs (only for files that exist)
      const uploadedFiles = [];
      if (photo)
        uploadedFiles.push(await uploadFile(photo, `photo_${username}`));
      if (degreeCertificate)
        uploadedFiles.push(
          await uploadFile(degreeCertificate, `degreeCertificate_${username}`)
        );
      if (aadhaarCard)
        uploadedFiles.push(
          await uploadFile(aadhaarCard, `aadhaarCard_${username}`)
        );
      if (registrationCertificate)
        uploadedFiles.push(
          await uploadFile(
            registrationCertificate,
            `registrationCertificate_${username}`
          )
        );
      if (additionalDegreeCertificate)
        uploadedFiles.push(
          await uploadFile(
            additionalDegreeCertificate,
            `additionalDegreeCertificate_${username}`
          )
        );

      // Prepare form values excluding the file objects
      const {
        photo: _,
        degreeCertificate: __,
        aadhaarCard: ___,
        registrationCertificate: ____,
        additionalDegreeCertificate: _____,
        ...restFormValues
      } = formValues;

      // Set the 'certificateImages' array with file URLs
      const updatedFormValues = {
        ...restFormValues,
        
      };

      // const certificateImages={
      //   certificateImages: ,
      // }

      // Save form data to Firestore
      // await setDoc(doc(db, "users", username), certificateImages, {
      //   merge: true,
      // });

       
     

      toast.success("Form data saved successfully!");
      
      Navigate("/payment", {
        state: { registrationData: updatedFormValues,certificateImages:uploadedFiles, username },
      });
    } catch (error) {
      toast.error("Error saving data: " + error.message);
    }
    finally {
      setLoading(false);
    }
  };

  
  

  return (
    <div className="registration-section">
      <Navbar />

      <div className="registration-form" id="registration-form">
        <div className="nav-container">
          <ToastContainer />
        </div>
        <h2 >REGISTRATION</h2>
        <div className="line-divider"></div>

        {currentStep === 1 && (
          <form>
            {/* Step 1: Input Fields */}
            <div className="nav-container-box" style={{ marginTop: '40px' }}>
              <div className="form-group">
                <label>First Name</label>

                <input

                  type="text"
                  name="firstName"
                  value={formValues.firstName}
                  onChange={handleInputChange}
                  placeholder="Dr."
                  required
                />
              </div>

              <div className="form-group">
                <label>Middle Name</label>
                <input
                  type="text"
                  name="middleName"
                  value={formValues.middleName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formValues.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="nav-container-box">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formValues.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formValues.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>WhatsApp Number</label>
                <input
                  type="tel"
                  name="whatsappNumber"
                  value={formValues.whatsappNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="nav-container-box2">
              <div className="form-group">
                <label>Date Of Birth</label>
                <input
                  type="date"
                  name="dob"
                  value={formValues.dob}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Aadhaar Card Number</label>
                <input
                  type="text"
                  name="aadhaarCardNumber"
                  value={formValues.aadhaarCardNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="nav-container-box">
              <div className="form-group">
                <label>Gender</label>
                <div className="radio-group">
                  <div className="radio-label">
                    <input
                      type="radio"
                      name="gender"
                      value="male"
                      checked={formValues.gender === "male"}
                      onChange={handleInputChange}
                      required
                    />
                    <label htmlFor="gender" style={{ marginTop: '10px' }}>Male</label>
                  </div>
                  <div className="radio-label">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      checked={formValues.gender === "female"}
                      onChange={handleInputChange}
                      required
                    />
                    <label htmlFor="gender" style={{ marginTop: '10px' }}>
                      Female
                    </label>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Qualification</label>
                <select
                  name="qualification"
                  value={formValues.qualification}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Select qualification
                  </option>
                  <option value="MBBS">MBBS</option>
                  <option value="BHMS">BAMS</option>
                  <option value="BAMS">BHMS</option>
                  <option value="BUMS">BUMS</option>
                  <option value="Other">Other</option>
                </select>
                {formValues.qualification === "Other" && (
                  <div className="form-group">
                    <label>Specify Qualification</label>
                    <input
                      type="text"
                      name="otherQualification"
                      value={formValues.otherQualification}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Specialization</label>
                <select
                  name="specialization"
                  value={formValues.specialization}
                  onChange={handleInputChange}
                  required
                >
                  <option value="" disabled>
                    Select specialization
                  </option>
                  <option value="MD">M.D.</option>
                  <option value="MS">M.S.</option>
                  <option value="Diploma">Diploma</option>
                  <option value="Other">Other</option>
                </select>
                {formValues.specialization === "Other" && (
                  <div className="form-group">
                    <label>Specify Specialization</label>
                    <input
                      type="text"
                      name="otherSpecialization"
                      value={formValues.otherSpecialization}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="nav-container-box2">
              <div className="form-group">
                <label>Address Line 1</label>
                <input
                  type="text"
                  name="address1"
                  value={formValues.address1}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="address2"
                  value={formValues.address2}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="nav-container-box2">
              <div className="form-group">
                <label>Registration Number</label>
                <input
                  type="text"
                  name="registrationNumber"
                  value={formValues.registrationNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Registration Date</label>
                <input
                  type="date"
                  name="registrationDate"
                  value={formValues.registrationDate}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="nav-container-box2">
              <div className="form-group">
                <label>Name Of Council</label>
                <input
                  type="text"
                  name="nameOfCouncil"
                  value={formValues.nameOfCouncil}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Renewal Date</label>
                <input
                  type="date"
                  name="renewalDate"
                  value={formValues.renewalDate}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-buttons">
              <button
                type="button"
                className="next-step-button"
                onClick={handleNextStep}
              >
                Next <GrFormNextLink className="next-icon" />
              </button>
            </div>
          </form>
        )}

        {currentStep === 2 && (
          <form onSubmit={handleSubmit}>
            {/* Step 2: Document Upload Fields */}
            <h3>Documents</h3>
            <div className="form-group">
              <label>
                Upload Your Photo (Size Upto 1MB, Only JPG,JPEG,PNG)
              </label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>

            <div className="form-group">
              <label>
                Degree Certificate (Size Upto 1MB, Only JPG,JPEG,PNG)
              </label>
              <input
                type="file"
                name="degreeCertificate"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Aadhaar Card (Size Upto 1MB, Only JPG,JPEG,PNG)</label>
              <input
                type="file"
                name="aadhaarCard"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="form-group">
              <label>
                Registration Certificate (Size Upto 1MB,Only JPG,JPEG,PNG)
              </label>
              <input
                type="file"
                name="registrationCertificate"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="form-group">
              <label>
                Additional Degree Certificate (Size Upto 1MB,Only JPG,JPEG,PNG)
              </label>
              <input
                type="file"
                name="additionalDegreeCertificate"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>

            <div className="form-buttons">
              <button type="submit">
                {loading ? <CircularProgress size={24} /> : 'Submit Form'}
              </button>
            </div>
          </form>
        )}
      </div>
      
      <Footer />
    </div>
  );
};

export default RegistrationForm;
